import axifyLogoTagline from "../assets/axifyLogoTagline.svg";
import { useTheme } from "../themes/ThemeContext";

function ClassicFooter({ appId, display, merchantURL }) {
	const handleExitClick = ( e ) => {
		e.preventDefault();
		if (display){
			return window.open(merchantURL, '_self')
		}else{
			return window.location.reload();
		}
	};

	const handleLogoClick = (e) => {
		e.preventDefault()
		return window.open("https://axify.ai/", '_self');
	};

	return(
		<footer id={"axify__widget-" + appId + "-footer"} className='axify__widget-footer layout-classic'>
			<div className="axify__widget-footer-inner">
				<div id={"axify__widget-" + appId + "-branding"} className="axify__widget-branding">
					<img id={"axify__footer-logo-image"} src={axifyLogoTagline} width="152" height="50" alt="Axify" onClick={handleLogoClick}/>
					<button id={"axify__widget-" + appId + "-exitBooking"} className="axify__widget-ui-button x-small ghost exit" onClick={handleExitClick}><span className="label">Exit Booking</span></button>
				</div>
			</div>
		</footer>
	);
}

function CompactFooter({ appId }) {
	const handleLogoClick = (e) => {
		e.preventDefault();
		window.open("https://axify.ai/", "_blank", "noopener,noreferrer");
	};

	return (
		<footer
			id={"axify__widget-" + appId + "-footer"}
			className="axify__widget-footer layout-compact"
		>
			<button
				type="button"
				className="axify__widget-footer-mark"
				onClick={handleLogoClick}
				aria-label="Powered by Axify — visit axify.ai"
			>
				Powered by Axify
			</button>
		</footer>
	);
}

function Footer(props) {
	const theme = useTheme();
	const layout = theme?.layout || "classic";
	return layout === "compact" ? <CompactFooter {...props} /> : <ClassicFooter {...props} />;
}

export default Footer;
